import { IDeprecatedFormAction, IFormAction } from '../../@types/entityTypes';
import { TaskPermission } from '../../graphql/entities/diary/DiaryEvent';
import React, { ReactElement, useContext, useEffect, useState } from 'react';
import ConnectedFormContext from '../../components/Context/ConnectedFormContext';
import { usePerformSave } from '../../components/connectedForm/Hooks/usePerformSave';
import ModalContext from '../../components/Context/ModalContext';
import AutomatedCreditControlRunWorkflowModal from '../../components/modals/AutomatedCreditControlWorkflowRunModal';

export enum AutomatedCreditControlWorkflowAction {
  PreviewWorkflow = 'PREVIEW_WORKFLOW',
  RunWorkflow = 'RUN_WORKFLOW',
}

export const formActionsForPermissions = [
  {
    actionReference: AutomatedCreditControlWorkflowAction.PreviewWorkflow,
  },
  {
    actionReference: AutomatedCreditControlWorkflowAction.RunWorkflow,
  },
];

const useRunWorkflowAction: (isPreview: boolean) => [IFormAction<AutomatedCreditControlWorkflowAction>, JSX.Element] = (
  isPreview
) => {
  const [modalOpen, setModalOpen] = useState(false);
  const connectedForm = useContext(ConnectedFormContext);
  let key;
  let text;
  let actionReference: AutomatedCreditControlWorkflowAction;
  if (!isPreview) {
    key = 'runWorkflow';
    text = 'Run Now';
    actionReference = AutomatedCreditControlWorkflowAction.RunWorkflow;
  } else {
    key = 'previewWorkflow';
    text = 'Preview';
    actionReference = AutomatedCreditControlWorkflowAction.PreviewWorkflow;
  }

  return [
    {
      key: key,
      text: text,
      condition: () => !!connectedForm?.values?.id,
      actionReference: actionReference,
      onClick: () => {
        setModalOpen(true);
      },
    },
    <ModalContext.Provider
      value={{
        onClose: () => {
          setModalOpen(false);
        },
      }}
    >
      <AutomatedCreditControlRunWorkflowModal isOpen={modalOpen} isPreview={isPreview} />
    </ModalContext.Provider>,
  ];
};

export const useAutomatedCreditControlWorkflowActions: () => [
  Array<IFormAction<AutomatedCreditControlWorkflowAction | TaskPermission>>,
  ReactElement
] = () => {
  const [confirmationModals] = usePerformSave();
  const [previewAction, previewModal] = useRunWorkflowAction(true);
  const [runAction, runModal] = useRunWorkflowAction(false);

  const salesOrderActions: Array<IFormAction<AutomatedCreditControlWorkflowAction | TaskPermission>> = [
    previewAction,
    runAction,
  ];

  return [
    salesOrderActions,
    <>
      {previewModal}
      {runModal}
      {confirmationModals}
    </>,
  ];
};
